module.exports = __webpack_public_path__ + "static/img/juice_1.d5e3a57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/juice_1.png
// module id = gu5M
// module chunks = 0